export default function(x) {
  return (x * x * x * (35 / 3072));
}


//////////////////
// WEBPACK FOOTER
// ./~/proj4/lib/common/e3fn.js
// module id = fGox
// module chunks = 0